import { useAxiosInterceptors } from "../../config/axios";
import { AxiosInstance } from "axios";


export const addAuthToHeader = (headers: any, token?: string) => {
  if (token) {
    return { ...headers, Authorization: 'Bearer ' + token }
  } else {
    if (Object.keys(headers).length === 0) {
      return undefined;
    }
    return headers;
  }
}

export class BaseModulePublicApi {
  basePath = '';
  domain = '';
  token: string | undefined;
  axiosInstance: AxiosInstance | undefined;

  constructor(domain: string, token?: string) {
    this.domain = domain;
    this.token = token;
    this.axiosInstance = useAxiosInterceptors();
  }

  async getList(offset: number, limit: number, headers: any, filters: any, orderby: any, configOptions?: any, params?: any,) {
    console.log('getList', `/front/${this.domain}/${this.basePath}`)
    const response = await this.axiosInstance!.get(`/front/${this.domain}/${this.basePath}`, { params: { offset, limit, ...orderby, ...filters, ...params }, headers: addAuthToHeader(headers ?? {}, this.token), ...configOptions });
    if (response.status === 200) {
      return response.data;
    }
  };

  async get(rowIdSlug: number | string, headers: any, configOptions?: any) {
    console.log('get', `/front/${this.domain}/${this.basePath}/${rowIdSlug}`)
    const response = await this.axiosInstance!.get(`/front/${this.domain}/${this.basePath}/${rowIdSlug}`, { headers: addAuthToHeader(headers ?? {}, this.token), ...configOptions });
    if (response.status === 200) {
      return response.data;
    }
  };

  async create(data: any, headers: any, configOptions?: any) {
    console.log('create', `/front/${this.domain}/${this.basePath}`)
    const response = await this.axiosInstance!.post(`/front/${this.domain}/${this.basePath}`, data, { headers: addAuthToHeader(headers ?? {}, this.token), ...configOptions });
    if (response.status === 201) {
      return response.data;
    }
  };

  async duplicate(rowId: number, data: any, headers: any, configOptions?: any) {
    console.log('update', `/front/${this.domain}/${this.basePath}`)
    const response = await this.axiosInstance!.post(`/front/${this.domain}/${this.basePath}/${rowId}`, data, { headers: addAuthToHeader(headers ?? {}, this.token), ...configOptions });
    if (response.status === 201) {
      return response.data;
    }
  };

  async update(rowId: number, data: any, headers: any, configOptions?: any) {
    console.log('update', `/front/${this.domain}/${this.basePath}`)
    const response = await this.axiosInstance!.put(`/front/${this.domain}/${this.basePath}/${rowId}`, data, { headers: addAuthToHeader(headers ?? {}, this.token), ...configOptions });
    if (response.status === 201) {
      return response.data;
    }
  };

  async delete(rowId: number, headers: any, configOptions?: any) {
    console.log('delete', `/front/${this.domain}/${this.basePath}/${rowId}`)
    const response = await this.axiosInstance!.delete(`/front/${this.domain}/${this.basePath}/${rowId}`, { headers: addAuthToHeader(headers ?? {}, this.token), ...configOptions });
    if (response.status === 200) {
      return response.data;
    }
  };

  async deleteBulk(rowIds: number[], headers: any, configOptions?: any) {
    console.log('deleteBulk', `/front/${this.domain}/${this.basePath}`)
    const response = await this.axiosInstance!.delete(`/front/${this.domain}/${this.basePath}`, { data: { ids: rowIds }, headers: addAuthToHeader(headers ?? {}, this.token), ...configOptions });
    if (response.status === 200) {
      return response.data;
    }
  };
};
